export const PLUGIN_ID = 'do-not-delete';
